export const WORKFLOW_OPTION_SLOT = 'workflow_option';
export const AUTO_CAPTURE_SLOTS_SLOT = 'auto_capture_slots';
export const SYS_LANGUAGE_SELECTED_SLOT = 'sys_language_selected'